import client from '@stores/apollo'
import gql from 'graphql-tag'
import { IPaginationInfo, IDashboardEmployeeImport } from '@api'
import { DashboardEmployeeImportFragment } from '@api/fragments'

export default function dashboardList({
  perPage,
  page = 1,
}: {
  perPage: number
  page: number
}): Promise<{
  pageInfo: IPaginationInfo
  imports: IDashboardEmployeeImport[]
}> {
  return client.gql.query({ query, variables: { perPage, page } }).then(
    ({
      data: {
        viewer: {
          company: {
            employeeImportDashboardConnection: { edges, pageInfo },
          },
        },
      },
    }: {
      data: {
        viewer: {
          company: {
            employeeImportDashboardConnection: {
              pageInfo: IPaginationInfo
              edges: IDashboardEmployeeImport[]
            }
          }
        }
      }
    }) => ({ pageInfo, imports: edges })
  )
}

const query = gql`
  query dashboardImportsQuery($perPage: Int!, $page: Int!) {
    viewer {
      company {
        employeeImportDashboardConnection(perPage: $perPage, page: $page) {
          pageInfo {
            currentPage
            perPage
            total
            totalPages
          }
          edges {
            ...DashboardEmployeeImportFragment
          }
        }
      }
    }
  }
  ${DashboardEmployeeImportFragment}
`
